module.exports = __webpack_public_path__ + "img/20190618161817892.76b4aa3b.png";